import { Tooltip } from "@material-ui/core";
import React, { useState, useEffect } from "react";

const defaultIcons = {
  avatar: () => `
    <svg width="100" height="100" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" stroke="black" strokeWidth="2"/>
      <circle cx="12" cy="10" r="4" fill="black"/>
      <path d="M6 18C6 15.7909 7.79086 14 10 14H14C16.2091 14 18 15.7909 18 18" stroke="black" strokeWidth="2"/>
    </svg>
  `,
  channel: () => `
  <svg width="100" height="100" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="12" fill="#E0E0E0"/>
    <path d="M7 10C7 9.44772 7.44772 9 8 9H16C16.5523 9 17 9.44772 17 10V14C17 14.5523 16.5523 15 16 15H8C7.44772 15 7 14.5523 7 14V10Z" fill="white"/>
    <circle cx="9" cy="12" r="1" fill="#3b5998"/>
    <circle cx="12" cy="12" r="1" fill="#00acee"/>
    <circle cx="15" cy="12" r="1" fill="#E1306C"/>
  </svg>
`,
  company: (name: string) => `
  <svg width="100" height="100" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <circle cx="50" cy="50" r="40" stroke="black" stroke-width="3" fill="lightblue" />
    <text x="50%" y="50%" text-anchor="middle" stroke="#000" stroke-width="1px" dy=".3em" font-size="15">${name}</text>
  </svg>
`,
};
interface ImageLoaderProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  imgUrl: string;
  resourceType: "avatar" | "channel" | "company";
  showTooltip?: boolean;
  whosCalling: string;
  label?: string;
}

export function ImageLoader(props: ImageLoaderProps) {
  const {
    imgUrl,
    resourceType,
    showTooltip,
    label = "Logo",
    whosCalling,
    ...htmlImgAttributes
  } = props;
  const [srcInternal, setSrcInternal] = useState("");

  useEffect(() => {
    const fetchImage = async () => {
      try {
        const response = await fetch(imgUrl);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        setSrcInternal(imgUrl);
      } catch (error) {
        const blob = new Blob([defaultIcons[resourceType](label)], {
          type: "image/svg+xml",
        });
        const url = URL.createObjectURL(blob);
        setSrcInternal(url);
      }
    };

    fetchImage();
  }, [imgUrl, label, resourceType]);

  return (
    <Tooltip
      arrow
      title={htmlImgAttributes.alt ?? resourceType}
      disableHoverListener={!showTooltip}
    >
      <img
        {...htmlImgAttributes}
        src={srcInternal}
        alt={htmlImgAttributes.alt ?? resourceType}
      />
    </Tooltip>
  );
}
